import React from "react";
import submit from "submit-form";
import ProfileListItem from "./ProfileListItem";
import Toast from "../../../../parts/toast";
import ClientGoals from "./ClientGoals";

import DailyGoals from "./DailyGoals";
import ClientInformation from "./ClientInformation";
import OnboardingInfo from "./OnboardingInfo";
import OnboardingSummary from "./OnboardingSummary";

const Dashboard = ({ athlete, locals }) => {
  const [state, setState] = React.useState({
    athleteId: athlete._id,
    goals: [],
    limitations: [],
    equipment: [],
  });

  const [shouldShowSuccessToast, setShouldShowSuccessToast] =
    React.useState(false);
  const [onboardingInfo, setOnboardingInfo] = React.useState(null);

  const { goals, equipment, limitations, _id: athleteId } = athlete;
  const coachOrganizationInformation =
    locals.coachOrganizationInformation || undefined;

  React.useEffect(() => {
    const verified = {
      goals: typeof goals === "object" ? goals : [],
      equipment: typeof equipment === "object" ? equipment : [],
      limitations: typeof limitations === "object" ? limitations : [],
    };
    setState({
      athleteId,
      goals: verified.goals,
      equipment: verified.equipment,
      limitations: verified.limitations,
    });
    setOnboardingInfo(null);
  }, [athlete]);

  const getSelector = (type) => {
    switch (type) {
      case "goals":
        return "goalId";
      case "equipment":
        return "equipmentId";
      case "limitations":
        return "limitationId";
      default:
        return "goalId";
    }
  };

  const addItem = (type) => {
    setShouldShowSuccessToast(false);
    const dat = state[type];
    dat.push({
      [getSelector(type)]:
        state[type].length > 0
          ? state[type][state[type].length - 1][getSelector(type)] + 1
          : 1,
      name: "",
      checked: false,
      creating: true,
    });
    setState((prevState) => Object.assign({}, prevState, { [type]: dat }));
  };

  const removeItem = (type, id, creating = false) => {
    setShouldShowSuccessToast(false);
    const dat = state[type];
    const filtered = dat.filter((d) => d[getSelector(type)] != id);
    setState((prevState) =>
      Object.assign({}, prevState, {
        [type]: filtered,
        creating: false,
        editing: false,
      })
    );
    if (!creating) sendRequest({ [type]: filtered });
  };

  const sendRequest = (values) => {
    let body = {
      goals: values.goals
        ? values.goals.filter((f) => !f.creating)
        : state.goals.filter((f) => !f.creating),
      limitations: values.limitations
        ? values.limitations
        : state.limitations.filter((f) => !f.creating),
      equipment: values.equipment
        ? values.equipment
        : state.equipment.filter((f) => !f.creating),
    };

    if (coachOrganizationInformation) {
      body = { ...body, coachOrganizationInformation };
    }

    submit(`/actions/user/update-athlete-profile/${state.athleteId}`, {
      method: "POST",
      body: body,
    });

    setShouldShowSuccessToast(true);
  };

  const modifyCallback = (type, id, values) => {
    const data = state[type].map((obj) => {
      return obj[getSelector(type)] === id ? Object.assign(obj, values) : obj;
    });

    sendRequest({ [type]: data });
    const newState = Object.assign({}, state, { [type]: data });
    setState(newState);
    // Send request to API to update item...
  };

  // Imma bout to do it to them
  if (onboardingInfo) {
    return (
      <OnboardingSummary
        onboardingInfo={onboardingInfo}
        setOnboardingInfo={setOnboardingInfo}
        locals={locals}
      />
    );
  }

  return (
    <div className="dashboard">
      <section className="dashboard-panel">
        <div>
          <DailyGoals locals={locals} />

          <ClientGoals locals={locals} />
        </div>
        <div>
          <OnboardingInfo
            locals={locals}
            setOnboardingInfo={setOnboardingInfo}
          />

          <ClientInformation locals={locals} />
        </div>
      </section>

      <div>
        <article>
          <header>Pinned Notes</header>
          <ul>
            {state.goals &&
              state.goals.map((goal, idx) => (
                <ProfileListItem
                  key={idx}
                  modifyCallback={modifyCallback}
                  removeItem={removeItem}
                  type="goals"
                  showChecked
                  itemSelector={getSelector("goals")}
                  {...goal}
                />
              ))}
          </ul>
          <button data-button-type="outline" onClick={() => addItem("goals")}>
            Add
          </button>
        </article>
        <article>
          <header>Limitations</header>
          <ul>
            {state.limitations &&
              state.limitations.map((limitation, idx) => (
                <ProfileListItem
                  key={idx}
                  modifyCallback={modifyCallback}
                  removeItem={removeItem}
                  type="limitations"
                  itemSelector={getSelector("limitations")}
                  {...limitation}
                />
              ))}
          </ul>
          <button
            data-button-type="outline"
            onClick={() => addItem("limitations")}
          >
            Add
          </button>
        </article>
        <article>
          <header>Equipment Available</header>
          <ul>
            {state.equipment &&
              state.equipment.map((equipment, idx) => (
                <ProfileListItem
                  key={idx}
                  modifyCallback={modifyCallback}
                  removeItem={removeItem}
                  type="equipment"
                  itemSelector={getSelector("equipment")}
                  {...equipment}
                />
              ))}
          </ul>
          <button
            data-button-type="outline"
            onClick={() => addItem("equipment")}
          >
            Add
          </button>
        </article>
      </div>
      <Toast open={shouldShowSuccessToast} message={"Profile updated"} />
    </div>
  );
};

module.exports = Dashboard;
